import { Badge, Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Mail from '@material-ui/icons/MailOutline';
import React from 'react';
import DialogSlideGlosas from './DialogSlideGlosas';

const styles = theme => ({
  buttonOperation: {
    fontSize: 'small',
    margin: theme.spacing(0.25),
    marginRight: theme.spacing(0.5),
    padding: theme.spacing(0.25),
    minWidth: theme.spacing(3),
    maxWidth: theme.spacing(3),
    minHeight: theme.spacing(3),
    maxHeight: theme.spacing(3),
  },
  badge: {
    top: '5%',
    right: 5,
    width: theme.spacing(2),
    height: theme.spacing(2),
    color: theme.palette.secondary.main,
    backgroundColor: 'transparent',
  },
});

class ButtonGlosas extends React.Component {
  state = {
    dialogOpen: false
  }

  handleCloseDialog = () => {
    this.setState({dialogOpen: false});
  }

  handleClick = () => {
    this.setState({dialogOpen: true});
  }

  render () {
    const { classes, title, glosas, emAuditoria, handleExcluirGlosa } = this.props;

    return (
      glosas && glosas.length > 0 &&
      <React.Fragment>
        <Badge badgeContent={glosas.length} color='secondary' classes={{ badge: classes.badge }}>
          <Button
            color='secondary'
            className={classes.buttonOperation}
            title='Glosas'
            onClick={this.handleClick}>
            <Mail />
          </Button>
        </Badge>
        <DialogSlideGlosas
          open={this.state.dialogOpen}
          title={title}
          glosas={glosas}
          emAuditoria={emAuditoria}
          handleClose={this.handleCloseDialog}
          handleExcluirGlosa={(codMensagemGlosa) => handleExcluirGlosa(codMensagemGlosa)}
        />
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(ButtonGlosas);
